/**
 * Single source of truth for marketing pricing.
 * Both /landing and /pricing import from here so the displayed prices
 * cannot drift between pages.
 */

export type Plan = "starter" | "growth" | "agency-pro";
export type Cycle = "monthly" | "annual";

export const PLAN_PRICES: Record<Plan, { monthly: number; annual: number }> = {
  starter: { monthly: 97, annual: 78 },
  growth: { monthly: 197, annual: 158 },
  "agency-pro": { monthly: 347, annual: 278 },
};

export function getPrice(plan: Plan, cycle: Cycle): number {
  return PLAN_PRICES[plan][cycle];
}

export function getAnnualSavings(plan: Plan): number {
  return (PLAN_PRICES[plan].monthly - PLAN_PRICES[plan].annual) * 12;
}

/** Marketing-friendly tier display data, keyed off the same prices. */
export const PLAN_DISPLAY: { key: Plan; name: string; tagline: string; features: string[]; highlighted?: boolean }[] = [
  {
    key: "starter",
    name: "Starter",
    tagline: "For solo owners ready to stop missing leads.",
    features: [
      "24/7 AI intake (Sarah)",
      "Lead scoring & hot-lead alerts",
      "Up to 100 leads / month",
      "Email & SMS notifications",
    ],
  },
  {
    key: "growth",
    name: "Growth",
    tagline: "For agencies scaling past their first 10 caregivers.",
    features: [
      "Everything in Starter",
      "AI referral outreach (14 source types)",
      "Unlimited leads",
      "Team accounts & roles",
      "Calendar + Zoom integration",
    ],
    highlighted: true,
  },
  {
    key: "agency-pro",
    name: "Agency Pro",
    tagline: "Multi-site agencies, group home networks, enterprise.",
    features: [
      "Everything in Growth",
      "Custom integrations",
      "Dedicated success manager",
      "BAA + custom compliance review",
      "Onboarding & migration support",
    ],
  },
];
